import { Center, Spinner } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import {
  useGetAuthenticatedPortalSourcingEventQuery,
  useGetBidQuery,
} from "../../../../autogen/bff-api";
import { useApiError } from "../../../../common/errors/useApiError";
import { PortalLayout } from "../components/PortalLayout";
import { EditBidForm } from "./EditBidForm";
import { isDesignContest } from "../../buyer/wizard/utils/designContest";
import { DesignContestEntryProvider } from "./designContestEntry";
import { BidReadonlyView } from "./readonly/BidReadonlyView";
import { showsReadonlyBid } from "./readonly/readonlyBidStatus";

export const EditBidPage = () => {
  const { eventId, bidId } = useParams<{ eventId: string; bidId: string }>();
  const displayer = useApiError();

  const bidQuery = useGetBidQuery({ bidId: bidId ?? "" }, { skip: !bidId });
  const eventQuery = useGetAuthenticatedPortalSourcingEventQuery({ eventId: eventId ?? "" }, { skip: !eventId });

  if (bidQuery.error) return displayer.show(bidQuery.error);
  if (eventQuery.error) return displayer.show(eventQuery.error);

  if (!eventId || !bidId || !bidQuery.data || !eventQuery.data) {
    return (
      <PortalLayout>
        <Center py="24">
          <Spinner color="smPrimary" />
        </Center>
      </PortalLayout>
    );
  }

  return (
    <DesignContestEntryProvider value={isDesignContest(eventQuery.data.procedureType)}>
      {showsReadonlyBid(bidQuery.data) ? (
        <BidReadonlyView eventId={eventId} bidId={bidId} bid={bidQuery.data} event={eventQuery.data} />
      ) : (
        <EditBidForm eventId={eventId} bidId={bidId} bid={bidQuery.data} event={eventQuery.data} />
      )}
    </DesignContestEntryProvider>
  );
};
